<template>
  <v-dialog
    v-model="showBenefitDialog"
    width="500"
    v-if="studyForm.benefit==null"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        v-bind="attrs"
        v-on="on"
        @click="loadBenefits"
        v-if="studyForm.benefit==null"
      >
        <v-icon small title="Criar">fas fa-plus</v-icon>
      </v-btn>
    </template>

    <v-card
      elevation="2"
      outlined
    >
      <v-card-title class="text-h5 muted lighten-2">
        Benefício
      </v-card-title>

      <v-card-text>
        <br>
        <v-autocomplete
          dense
          outlined
          v-model="value"
          :items="benefitItems"
          item-text="name"
          item-value="id"
          label="Benefício"
          :clearable="true"
          return-object
          :loading="this.benefitItems.length == 0"
        ></v-autocomplete>
        
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          @click="showBenefitDialog = false; studyForm.benefit = value; value=null; loadQuoteReasons()"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BenefitService from "@/services/odoo/BenefitService";

export default {
  props: {
    studyForm: {
      type: Object
    },
    getQuoteReasons: Function,
  },
  data() {
    return {
      showBenefitDialog: false,
      benefitItems: [],
      value: null
    };
  },
  async created() {
    this._benefitService = new BenefitService();
  },
  methods: {
    loadBenefits(){
      /*if (this.benefitItems.length==0) {
        this._benefitService.findAll().then((res) => this.benefitItems = res.data.records);
      }*/
      this.benefitItems = this.studyForm.studyConfiguration.benefits;
    },
    loadQuoteReasons(){
      console.log("loadQuoteReasons - inicio");
      this.getQuoteReasons();
      console.log("loadQuoteReasons - fim");
    }
  }
};
</script>
